import { Controller } from "@api/config";
import type { IRequestConfig } from "@api/config";

import { TGetSessionTokenResponse } from "./response.types";

class ToysController extends Controller {
	public constructor() {
		super({ requestUrl: "models/toys/" });
	}

	/**@POST SESSION TOKEN */
	public async getSessionTokenAsync({ token, signal }: IRequestConfig) {
		return this.post<TGetSessionTokenResponse>("sessionToken", null, { token, signal });
	}
}

export const toysAPI = new ToysController();
